import React from 'react';
import { RocketLaunchIcon, BookOpenIcon, WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const articlesAndGuides = [
  {
    title: 'Blog: How to give clear feedback with EQ and empathy',
    url: 'https://m13.co/article/how-to-give-clear-feedback-with-eq-and-empathy',
    description: 'Blog on how to give high EQ feedback by LifeLabs',
  },
  {
    title: 'How to give CORE feedback',
    url: 'https://www.radicalcandor.com/core-feedback/',
    description: 'Guide by Radical Candor team',
  },
  {
    title: 'How to give EEC feedback',
    url: 'https://www.hivelearning.com/site/resource/diversity-inclusion/your-2-minute-guide-to-giving-feedback/',
    description: 'Guide by hivelearning',
  },
  {
    title: 'How to ask for feedback',
    url: 'https://www.radicalcandor.com/asking-for-feedback/',
    description: 'Guide by Radical Candor team',
  },
  {
    title: 'What to do if you disagree with feedback',
    url: 'https://www.radicalcandor.com/disagreeing-feedback/',
    description: 'Guide by Radical Candor team',
  },
  {
    title: '10 different feedback models',
    url: 'https://join.com/recruitment-hr-blog/feedback-models',
    description: 'Collection of feedback models and frameworks',
  },
];

const templatesAndTools = [
  {
    title: 'Leading Feedback (Notion Template)',
    url: 'https://www.notion.so/Leading-Feedback-ceb95bbf6fac4803b1dd9f4efabb5339?pvs=21',
    description: 'Notion template for leading feedback sessions',
  },
  {
    title: 'How to: Feedback (Checkly)',
    url: 'https://www.notion.so/How-to-Feedback-Checkly-bcd5828c16834875bdf6989b2084f682?pvs=21',
    description: 'Feedback implementation guide from Checkly',
  },
];

const FeedbackCultureUsefulResources = () => {
  return (
    <div className="space-y-8">
      <PlaybookSection
        title="Useful Resources"
        icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />}
        heading
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <PlaybookCard>
            <ResourceList
              title="Articles & Guides"
              items={articlesAndGuides}
              icon={BookOpenIcon}
            />
          </PlaybookCard>
          <PlaybookCard>
            <ResourceList
              title="Templates & Tools"
              items={templatesAndTools}
              icon={WrenchScrewdriverIcon}
            />
          </PlaybookCard>
        </div>
      </PlaybookSection>
    </div>
  );
};

export default FeedbackCultureUsefulResources; 